import { formatLocalAirtime } from './countdownTime.ts'
import { roomGuidelines } from './roomGuidelines.ts'

type PostingNotice = {
  loaded: boolean
  canPost: boolean
  adminAccess: boolean
  opensAt: string | null
  state: 'pre' | 'live' | 'post' | 'locked'
}

// Permission comes from the authenticated server response, never a client role guess.
export function livePostingNotice(access: PostingNotice, locale?: string) {
  if (!access.loaded) return 'Checking when member chat opens…'
  if (access.adminAccess && access.canPost) return 'Admin access: you can post anytime.'
  if (access.canPost) return 'Member chat is open. Posting closes 1 hour after the show ends.'
  if (access.state === 'locked') return 'Member chat is closed. You can still read the room.'
  const opens = access.opensAt ? new Date(access.opensAt) : null
  if (opens && Number.isFinite(opens.getTime())) {
    return `Member chat opens ${formatLocalAirtime(opens, locale)} — 1 hour before showtime.`
  }
  return `${roomGuidelines.timing} You can still read the room.`
}
